/* ===============================
   Description toggle
================================ */
document.querySelectorAll('.description-toggle').forEach(button => {
  button.addEventListener('click', function () {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    const container = this.nextElementSibling;

    this.setAttribute('aria-expanded', String(!isExpanded));
    container.classList.toggle('is-open', !isExpanded);
  });
});

/* ===============================
   Essential Upsell customization
   (optimized: bounded MutationObserver — disconnects once
   the widget's DOM has settled, instead of listening forever)
================================ */
document.addEventListener('DOMContentLoaded', () => {
  const APP_BLOCK_SELECTORS = [
    'essential-upsell-frequently-bought-together-app-block',
    'essential-upsell-cross-sell-app-block'
  ];

  APP_BLOCK_SELECTORS.forEach(selector => {
    const appBlock = document.querySelector(selector);
    if (!appBlock) return;

    // Максимальна кількість повторних спроб стилізації після мутацій.
    // Досить, щоб пережити асинхронне довантаження товарів/цін віджетом,
    // але не тримати спостерігач активним увесь час життя сторінки.
    const MAX_ATTEMPTS = 8;
    // Скільки поспіль мутацій підряд не додали нічого нового,
    // перш ніж вважати DOM "стабільним" і відключити спостерігач.
    const STABLE_THRESHOLD = 3;

    let attempts = 0;
    let stableStreak = 0;
    let debounceId = null;

    const isFullyStyled = () => {
      const root = appBlock.shadowRoot || appBlock;
      const container = root.querySelector('[data-essential-upsell-element="container"]');
      const buttons = root.querySelectorAll('[data-essential-upsell-element="add-to-cart-button"]');

      if (!container || !container.dataset.customStyled) return false;
      if (buttons.length === 0) return false;

      return Array.from(buttons).every(btn => btn.dataset.customCtaApplied);
    };

    const runApply = () => {
      applyUpsellCustomizations(appBlock);
      attempts++;

      if (isFullyStyled()) {
        stableStreak++;
      } else {
        stableStreak = 0;
      }

      if (stableStreak >= STABLE_THRESHOLD || attempts >= MAX_ATTEMPTS) {
        observer.disconnect();
      }
    };

    // Пробуємо одразу — можливо, віджет уже відрендерений на момент DOMContentLoaded.
    runApply();

    const observer = new MutationObserver(() => {
      // Дебаунс: віджет часто випускає кілька мутацій підряд
      // (наприклад, кожен товар/картинка окремо) — обробляємо їх однією групою,
      // а не запускаємо applyUpsellCustomizations на кожну окрему мутацію.
      if (debounceId) clearTimeout(debounceId);
      debounceId = setTimeout(runApply, 50);
    });

    // Якщо після MAX_ATTEMPTS спостерігач ще не відключився сам —
    // підстрахуємось жорстким тайм-аутом, щоб він не жив вічно.
    if (!isFullyStyled()) {
      observer.observe(appBlock, {
        childList: true,
        subtree: true
      });
      setTimeout(() => observer.disconnect(), 15000);
    }
  });
});

function applyUpsellCustomizations(appBlock) {
  const root = appBlock.shadowRoot || appBlock;

  const container = root.querySelector('[data-essential-upsell-element="container"]');
  const header = root.querySelector('[data-essential-upsell-element="header"]');
  const title = root.querySelector('[data-essential-upsell-element="title"]');
  const products = root.querySelectorAll('[data-essential-upsell-element="product"]');
  const buttons = root.querySelectorAll(
    '[data-essential-upsell-element="add-to-cart-button"]'
  );

  /* ---------- Container ---------- */
  if (container && !container.dataset.customStyled) {
    container.style.cssText = `
      background-color: #d6e4fa !important;
      padding: 16px;
      margin-top: 24px;
      border-radius: 8px;
    `;
    container.dataset.customStyled = 'true';
  }

  /* ---------- Title ---------- */
  if (title) {
    if (title.textContent !== 'COMPLETE THE SET & SAVE 25%') {
      title.textContent = 'COMPLETE THE SET & SAVE 25%';
    }

    title.style.fontSize = '20px';
    title.style.marginBottom = '4px';
    title.style.padding = '0';

    // Add subtitle
    let subtitle = title.nextElementSibling;

    if (!subtitle || !subtitle.classList.contains('upsell-subtitle')) {
      subtitle = document.createElement('p');
      subtitle.className = 'upsell-subtitle';
      subtitle.textContent = 'Buy 4 matching files together and get 25% off your bundle';

      subtitle.style.margin = '0 0 12px';
      subtitle.style.fontSize = '14px';
      subtitle.style.lineHeight = '1.4';
      subtitle.style.color = '#666';

      title.insertAdjacentElement('afterend', subtitle);
    }
  }

  /* ---------- Header ---------- */
  if (header) {
    header.style.padding = '0';
    header.style.flexDirection = 'column';
    header.style.alignItems = "start";
  }

  /* ---------- Products ---------- */
  products.forEach(item => {
    if (!item.dataset.customStyled) {
      item.style.backgroundColor = 'transparent';
      item.dataset.customStyled = 'true';
    }
  });

  /* ---------- CTA Button (SAFE) ---------- */
  buttons.forEach(button => {
    if (button.dataset.customCtaApplied) return;

    // Remove ONLY direct text nodes (prices are spans)
    Array.from(button.childNodes).forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.remove();
      }
    });

    // Insert CTA text before prices
    const textNode = document.createTextNode('Add 4 files & save 25% • ');
    button.insertBefore(textNode, button.firstChild);

    button.dataset.customCtaApplied = 'true';
  });
}